import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage} from "../../panels/BasePanelPage";
import {
    LoginWithEmailCode,
    LoginWithEmailCodeStyle
} from "../../../../website/unauthenticated/slides/LoginWithEmailCodeForm";
import {styleRule, styleRuleInherit} from "../../../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {Messages} from "../../../../Messages";
import {Router} from "../../../../../stem-core/src/ui/Router";
import {MessageElement} from "../../../../widget/ui/MessageElement";
import {authFormService} from "../../../../services/AuthFormService";
import {userService} from "../../../../../client/connection/services/UserService";
import {LoadingSpinner} from "../../../../ui/LoadingSpinner";
import {apiConfirmUserEmailChange} from "../../../../../client/state/UserProfileStore";
import {DefaultCodeConfirmationForm} from "../../../../common/DefaultCodeConfirmationForm";
import {PanelToast} from "../../../PanelToast";
import {INLINE_USER_DASHBOARD_URLS} from "../../../PanelConstants";


class InlineUserDashboardChangeEmailCodeConfirmationComponentStyle extends LoginWithEmailCodeStyle {
    @styleRuleInherit
    component = {
        " input": {
            borderColor: this.themeProps.MERCHANT_INPUT_BORDER_COLOR,
            background: this.themeProps.MERCHANT_INPUT_BACKGROUND,
        },
        " input:focus": {
            borderColor: this.themeProps.MERCHANT_INPUT_BORDER_ACTIVE_COLOR,
        },
    };

    @styleRule
    title = this.themeProps.PANEL_TITLE;
}

@registerStyle(InlineUserDashboardChangeEmailCodeConfirmationComponentStyle)
class InlineUserDashboardChangeEmailCodeConfirmationComponent extends LoginWithEmailCode {
    canDisplayResendCodeOption = false;

    getEmailConfirmationFormClass() {
        return DefaultCodeConfirmationForm;
    }

    getBeforeInput() {
        return [
            <div className={this.styleSheet.title}>{Messages.confirmEmailChangeModalTitle}</div>,
            <div className={this.styleSheet.text}><MessageElement message={Messages.confirmEmailChangeLine1} args={[authFormService.changeToEmailAddress]}/></div>,
            <div className={this.styleSheet.text}><MessageElement message={Messages.confirmEmailChangeLine2} args={[authFormService.changeToEmailAddress, userService.getUserEmail()]}/></div>,
        ];
    }

    async handleSubmit(code) {
        LoadingSpinner.show();
        try {
            await apiConfirmUserEmailChange({code});
            PanelToast.showSuccess(Messages.emailSuccessfullyChanged);
        } catch (error) {
            PanelToast.showError(error && error.message ? error.message : Messages.errorWhileSaving);
        } finally {
            LoadingSpinner.hide();
        }
        Router.changeURL(INLINE_USER_DASHBOARD_URLS.home);
    }
}

export class InlineUserDashboardChangeEmailCodeConfirmPanel extends BasePanelPage {
    render() {
        return <InlineUserDashboardChangeEmailCodeConfirmationComponent />;
    }
}
